export enum MetadataKeys {
  CONTROL_VALIDATORS = 'rxap/forms/control-validators',
  CONTROL_ASYNC_VALIDATORS = 'rxap/forms/control-async-validators',
  CONTROL_CHANGES = 'rxap/forms/control-changes',
  CONTROL_SET_VALUE = 'rxap/forms/control-set-value',
  FORM_ARRAY_GROUPS = 'rxap/forms/form-array-groups',
  FORM_ARRAY_CONTROLS = 'rxap/forms/form-array-controls',
  FORM_GROUPS = 'rxap/forms/form-groups',
  FORM_CONTROLS = 'rxap/forms/form-controls'
}
